import {
  descriptionUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import SponsorSignInAlert from '../../components/FormAlerts/SponsorSignInAlert';
import EligibilityDescription from '../../components/FormDescriptions/EligibilityDescription';
import { blankSchema } from '../../definitions';
import content from '../../locales/en/content.json';
import { roleIsNotSponsor } from '../../utils/helpers/certifier';

export default {
  uiSchema: {
    ...titleUI(content['eligibility--overview-title']),
    ...descriptionUI(EligibilityDescription),
    'view:sponsorSignInAlert': descriptionUI(SponsorSignInAlert, {
      hideIf: roleIsNotSponsor,
    }),
  },
  schema: {
    type: 'object',
    properties: {
      'view:sponsorSignInAlert': blankSchema,
    },
  },
};
